import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Select from 'react-select';
import { get } from '@cullylarson/f';
import { idFromPrefix } from '@@client/lib/forms';
import FormField from './FormField';
export default function FormSelect(_ref) {
  var idPrefix = _ref.idPrefix,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? null : _ref$id,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      onMenuOpen = _ref.onMenuOpen,
      options = _ref.options,
      _ref$isClearable = _ref.isClearable,
      isClearable = _ref$isClearable === void 0 ? true : _ref$isClearable,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? true : _ref$isSearchable,
      _ref$filterOption = _ref.filterOption,
      filterOption = _ref$filterOption === void 0 ? undefined : _ref$filterOption,
      _ref$isMulti = _ref.isMulti,
      isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      maxMenuHeight = _ref.maxMenuHeight,
      _ref$noOptionsPlaceho = _ref.noOptionsPlaceholder,
      noOptionsPlaceholder = _ref$noOptionsPlaceho === void 0 ? null : _ref$noOptionsPlaceho,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Select...' : _ref$placeholder,
      ariaLabel = _ref['aria-label'],
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? null : _ref$autoComplete,
      formFieldAtts = _objectWithoutProperties(_ref, ["idPrefix", "id", "name", "value", "onChange", "onMenuOpen", "options", "isClearable", "isSearchable", "filterOption", "isMulti", "disabled", "maxMenuHeight", "noOptionsPlaceholder", "placeholder", "aria-label", "autoComplete"]);

  placeholder = noOptionsPlaceholder && (!options || !options.length) ? noOptionsPlaceholder : placeholder;
  id = id || idFromPrefix(idPrefix, name);
  var errorId = id + '--error';

  var handleChange = function handleChange(x) {
    return onChange(Array.isArray(x) ? x.map(get('value', null)).filter(function (x) {
      return !!x;
    }) : get('value', null, x));
  };

  var selectedValue = !value ? value : options.filter(function (x) {
    return Array.isArray(value) ? value.includes(x.value) : value === x.value;
  });
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    errorId: errorId,
    inputId: id
  }, formFieldAtts), {}, {
    children: /*#__PURE__*/_jsx(Select, {
      className: "react-select",
      classNamePrefix: "react-select",
      inputId: id,
      name: name,
      placeholder: placeholder,
      value: selectedValue,
      options: options,
      onChange: handleChange,
      onMenuOpen: onMenuOpen,
      isClearable: isClearable,
      isSearchable: isSearchable,
      filterOption: filterOption,
      isMulti: isMulti,
      isDisabled: disabled,
      "aria-label": ariaLabel,
      "aria-describedby": errorId,
      maxMenuHeight: maxMenuHeight,
      autoComplete: autoComplete
    })
  }));
}